import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { myPalette } from '~/shared/ui/theme'
import { Circle, Degree, Img, ItemsList, ItemWrapper, Title } from './styled'

export function LegendModal() {
  const { t } = useTranslation()
  const { isModalShow, openModal, closeModal } = useModal()

  return (
    <>
      <Button
        variant='textBlue'
        uppercase
        onClick={openModal}
        contentProps={{ style: { padding: 0 } }}
      >
        {t('legend')}
      </Button>

      <Modal
        isShow={isModalShow}
        onCancel={closeModal}
        reverseButton
        cancel={t('button.close')}
      >
        <Title>{t('legend')}</Title>
        <ItemsList>
          <ItemWrapper>
            <Degree>{t('damageParams.L')}</Degree> - {t('damageParams.light')}
          </ItemWrapper>
          {/*<ItemWrapper>*/}
          {/*  <Degree>{t('damageParams.M')}</Degree> - {t('damageParams.medium')}*/}
          {/*</ItemWrapper>*/}
          <ItemWrapper>
            <Degree>{t('damageParams.S')}</Degree> - {t('damageParams.severe')}
          </ItemWrapper>

          <ItemWrapper>
            <Img src='/images/marker.svg' alt='marker' />-{' '}
            {t('identified in this inspection')}
          </ItemWrapper>
          <ItemWrapper>
            <Circle $background={myPalette.orange['100']} />-{' '}
            {t('identified in previous inspections')}
          </ItemWrapper>
          <ItemWrapper>
            <Circle $background={myPalette.limeGreen.main} />-{' '}
            {t('repaired damage')}
          </ItemWrapper>
        </ItemsList>
      </Modal>
    </>
  )
}
